import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/v2/components/ui/dialog";
import { Button } from "@/v2/components/ui/button";

/**
 * The one delete-a-channel confirmation. Used by the Personal Channel page
 * (header button and channel switcher rows) and by the Studio's spotlight
 * cards, so the wording and the destructive styling stay identical wherever
 * a channel can be deleted.
 *
 * Presentational on purpose: each caller already owns its own delete call
 * (v1 HttpService on the Personal Channel page, a react-query mutation in the
 * Studio), so this takes onConfirm plus an isDeleting flag rather than
 * fetching anything itself.
 */
export function DeleteChannelDialog({
  open,
  onClose,
  onConfirm,
  channelName,
  isDeleting,
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  /** Named whenever the caller knows it: deleting is not undoable, and the
   *  switcher rows can target a channel other than the one on screen. */
  channelName?: string;
  isDeleting?: boolean;
}) {
  return (
    <Dialog open={open} onOpenChange={(next) => !next && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {channelName ? `Delete "${channelName}"?` : "Delete this Spotlight?"}
          </DialogTitle>
          <DialogDescription>
            This removes the Spotlight and its configuration. This cannot be
            undone.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={onConfirm} disabled={isDeleting}>
            {isDeleting ? "Deleting…" : "Delete"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
